import { ContactType } from "src/Types/ReDoc/Contact";
import { Contact } from "../../Components";
import './style.scss';

interface IContactListProps {
	list?: Array<ContactType>;
};

const ContactList: React.FC<IContactListProps> = ({ list = [] }) => (
	<div className="contacts">
		<h3 className="headline-large contacts__title">Связаться со службой поддержки:</h3>
		<ul className="contacts__list">
			{
				list.map( (contact, index) => (
					<li id={"contact_" + index} key={"contact_" + index}>
						<Contact {...contact} />
					</li>
				))
			}
		</ul>
	</div>
);

export default ContactList;
